<span [innerHTML]="timex" class="app-match-time"></span>
@if (stoppageTimeAnnouncedIn) {
  <div
    class="stoppageTimeAnnounced"
    title="{{ 'web.stoppage_time_annouced' | translate }}"
    >
    <i class="fas fa-stopwatch"></i> {{ stoppageTimeAnnouncedIn }}
  </div>
}
